// svelte
import { writable } from 'svelte/store';

// packages
import { v4 as uuidv4 } from 'uuid';

// lib
import { getCurrentTime } from '$lib/utilities/dateTime';

// types
import type { Notification, UserCreatedNotification } from '$types/Notification';

const createToastNotifications = () => {
	const { subscribe, set, update } = writable<Notification[]>([]);

	return {
		subscribe,
		create: ({ description, kind, title }: UserCreatedNotification) => {
			// create the notification id
			const id = uuidv4();
			// add the notification to the beginning of the list
			update((n) => [
				{
					id,
					createdAt: getCurrentTime(),
					description,
					kind,
					title,
				},
				...n,
			]);

			// if the list would be greater than 3, delete the oldest notification
			toastNotifications.subscribe(
				(n) => n.length > 3 && toastNotifications.deleteNotification(n[3].id),
			);

			// remove the notification after 6 seconds
			setTimeout(() => {
				toastNotifications.deleteNotification(id);
			}, 6000);
		},
		deleteNotification: (id: string) => update((n) => n.filter((i) => i.id !== id)),
		deleteNotifications: () => set([]),
	};
};

const toastNotifications = createToastNotifications();

export default toastNotifications;
